enum MobileModeHint {
  Mobile = 'mobile',
  NotMobile = 'notMobile',
}
export default MobileModeHint;
